export default __webpack_public_path__ + "static/media/layout-2.8582036f.jpg";